import React, { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import Navbar from '@organisms/navbar/navbar';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import {
  Operating_System_State,
  Full_Page_Loading_State,
  Is_User_Available_State,
} from '@recoil/recoil';

import PrivacyStatementModal from '@organisms/modals/privacyStatementModal';
import { OPERATING_SYSTEM } from '@constants/commonConstants';
import { CenteredSpinner, LoadingOverlayContainer } from '@styles/commonStyledComponents';
import SpinnerLoader from '@atoms/SpinnerLoader';
// import { setNavigateFunction } from '@services/navigationService';
// import NoOpportunityFoundModal from '@organisms/modals/noOpportunityFoundModal';
import SubmissionFailureModal from '@organisms/modals/submissionFailureModal';
import SessionExpireModal from '@organisms/modals/sessionExpireModal';
import MessageModal from '@organisms/modals/messageModal';

const Layout = () => {
  const setOsInfo = useSetRecoilState(Operating_System_State);
  const isUserAvailable = useRecoilValue(Is_User_Available_State);
  const isFullPageLoading = useRecoilValue(Full_Page_Loading_State);

  const navigate = useNavigate();

  // useEffect(() => {
  //   setNavigateFunction(navigate);
  // }, [navigate]);

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    let osName = 'Unknown';

    if (userAgent.indexOf('Win') !== -1) {
      osName = OPERATING_SYSTEM.WINDOWS;
    } else if (userAgent.indexOf('Mac') !== -1) {
      osName = OPERATING_SYSTEM.MAC;
    } else if (userAgent.indexOf('Linux') !== -1) {
      osName = OPERATING_SYSTEM.LINUX;
    } else if (userAgent.indexOf('Android') !== -1) {
      osName = OPERATING_SYSTEM.ANDROID;
    } else if (userAgent.indexOf('iOS') !== -1) {
      osName = OPERATING_SYSTEM.IOS;
    }
    setOsInfo(osName);
  }, []);

  useEffect(() => {
    if (localStorage.getItem('isReadOnly') === 'true') {
      navigate('/forecast');
    }
    if (localStorage.getItem('mslDelegate')) {
      navigate('/forecast');
    }
  }, []);

  return (
    <>
      {isFullPageLoading ? (
        <LoadingOverlayContainer>
          <CenteredSpinner>
            <SpinnerLoader color="#155CB4" />
          </CenteredSpinner>
        </LoadingOverlayContainer>
      ) : null}
      <Navbar></Navbar>
      {/* <Breadcrumb></Breadcrumb> */}
      <div style={{ width: '100%', height: '100%', paddingTop: '56px' }}>
        <div className="motif-container-fluid no-gutters">
          <Outlet />
          <MessageModal />
          {/* {!isUserAvailable && isUserAvailable !== null ? <NoOpportunityFoundModal /> : null} */}
          {isUserAvailable &&
          isUserAvailable !== null &&
          !sessionStorage.getItem('isPrivacyPopupClosedOnce') ? (
            <PrivacyStatementModal />
          ) : null}
          <SubmissionFailureModal />
        </div>
        <SessionExpireModal />
      </div>
    </>
  );
};

export default Layout;
